const mutations = {
  // 设置是否展示拦截提示
  muSetImmediateStrategyData(state, data) {
    state.immediateStrategyData = data;
  },
  // 设置拦截提示显示时间
  muSetPromptShowTime(state, data) {
    state.promptShowTime = data;
  },
  // 设置是否展示拦截提示
  muSetShowPrompt(state, { isShowSell, isShowPay }) {
    state.isShowSellPrompt = isShowSell;
    state.isShowPayPrompt = isShowPay;
  },
  // 设置倒计时信息
  muSetCountDown(state, date) {
    state.isShowSellCountDown = date.isSellCount;
    state.isShowPayCountDown = date.isPayCount;
    state.sellCountDownDuring = date.sellDate;
    state.payCountDownDuring = date.payDate;
    state.sellDuring = date.sellDuring;
    state.payDuring = date.payDuring;
  },
  // 设置剩余名额
  muSetCourseQuota(state, num) {
    state.courseQuota = num;
  },
  // 设置手机号滚动
  muSetPhoneRoll(state, status) {
    state.isPhoneRoll = status;
  },
  // 设置登陆状态
  muSetIsLogin(state, status) {
    state.isLogin = status;
  },
  // 设置登陆状态
  muSetPreSave(state, data) {
    state.preSaveData = data;
  },
};
export default mutations;
